import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Router} from '@angular/router';
import {FILE_UPLOADER} from 'src/app/componentes/file-uploader/file-uploader.component';
import {ConsultaVO} from 'src/app/entity/ConsultaVO';
import {AuthService} from 'src/app/service/autenticacao/auth.service';
import {ConsultaService} from 'src/app/service/consulta/consulta.service';
import {
  ERRO_ASSUNTO_OBRIGATORIO,
  ERRO_DADOS_NAO_GRAVADOS,
  ERRO_DADOS_OBRIGATORIOS,
  OK_MANIFESTO_ENVIADO
} from 'src/app/tools/Mensagens';
import {PAGINA_SUCESSO_FORM} from 'src/app/tools/URL';
import { CartoriosExtrajudicialConsultaComponent } from './cartorios-extrajudicial-consulta/cartorios-extrajudicial-consulta.component';

@Component({
  selector: 'consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.css']
})
export class ConsultaComponent implements OnInit {
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  @ViewChild(CartoriosExtrajudicialConsultaComponent, { static: false }) cartoriosExtrajudicialConsulta: CartoriosExtrajudicialConsultaComponent;

  constructor(public service: ConsultaService,
    public authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.service.carregarDados().subscribe(retorno => {
      console.log(retorno);
      this.service.consulta.controls.nome.setValue(this.authService.usuarioDTO.nome);
      this.service.consulta.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.consulta.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.consulta.controls.assuntos.setValue(retorno.assuntos);
        this.checarAssuntoUnico();
      }
    });
  }

  checarAssuntoUnico() {
    if (this.service.consulta.controls.assuntos.value != null && this.service.consulta.controls.assuntos.value.length == 1) {
      this.changeAssunto(this.service.consulta.controls.assuntos.value[0]);
    }
  }

  onSubmit() {
    if (!this.service.consulta.value.assunto) {
      alert(ERRO_ASSUNTO_OBRIGATORIO);
      return;
    }

    this.preencherDados();

    if (!this.service.consulta.valid) {
      const campos = this.tratarMensagemDeErro();
      alert(ERRO_DADOS_OBRIGATORIOS + campos);
      return;
    }

    const isRestituicao =
      this.cartoriosExtrajudicialConsulta &&
      this.cartoriosExtrajudicialConsulta.mostrarRestituicaoForm;

    if (isRestituicao) {
      const restituicaoPayload = this.cartoriosExtrajudicialConsulta.obterRestituicaoPayloadSeValido();

      if (!restituicaoPayload) {
        alert(ERRO_DADOS_OBRIGATORIOS + ' Requerimento de restituição de valores recolhidos aos Fundos do FDMP, FEGAJ e FEAGE');
        return;
      }

      this.service.enviarConsultaComRestituicao({
        consulta: this.service.consulta.value,
        restituicao: restituicaoPayload
      }).subscribe(retorno => {
        if (retorno) {
          alert(OK_MANIFESTO_ENVIADO);
          this.router.navigate([PAGINA_SUCESSO_FORM]);
        } else {
          alert(ERRO_DADOS_NAO_GRAVADOS);
        }
      });
    } else if (this.isMonitoramentoConciliacao) {
      const monitoramentoConciliacao = this.cartoriosExtrajudicialConsulta.obterMonitoramentoConciliacaoPayloadSeValido();

      if (!monitoramentoConciliacao) {
        alert(ERRO_DADOS_OBRIGATORIOS +
          ' Monitoramento das Atividades de Conciliação e Mediação dos Serviços Notariais e de Registro');
        return;
      }

      this.service.enviar({ ...this.service.consulta.value, monitoramentoConciliacao }).subscribe(retorno => {
        if (retorno) {
          alert(OK_MANIFESTO_ENVIADO);
          this.router.navigate([PAGINA_SUCESSO_FORM]);
        } else {
          alert(ERRO_DADOS_NAO_GRAVADOS);
        }
      });
    } else {
      this.service.enviar(this.service.consulta.value).subscribe(retorno => {
        if (retorno) {
          alert(OK_MANIFESTO_ENVIADO);
          this.router.navigate([PAGINA_SUCESSO_FORM]);
        } else {
          alert(ERRO_DADOS_NAO_GRAVADOS);
        }
      });
    }
  }

  tratarMensagemDeErro() {
    let campos: String[] = [];
    let construtor: any = ConsultaVO.prototype.constructor;

    Object.values(this.service.consulta.controls).forEach((value: AbstractControl) => {
      if (!value.valid) {
        const formGroup = value.parent.controls;
        campos.push("\n" + construtor.descricaoAtributos[Object.keys(formGroup).find(name => value === formGroup[name])]);
      }
    });
    return campos;
  }

  preencherDados() {
    this.service.consulta.controls.nome.setValue(this.authService.usuarioDTO.nome);
    this.service.consulta.controls.email.setValue(this.authService.usuarioDTO.email);
    this.service.consulta.value.files = [];
    if (this.fileUploader) {
      this.fileUploader.mapFilesBase64.forEach((value, key) => {
        this.service.consulta.value.files.push({
          nomeArquivo: key,
          conteudo: value
        });
      });
    }
  }

  changeAssunto(item) {
    this.service.consulta.controls.assunto.setValue(item);
  }

  isChecked(item) {
    return this.service.consulta.controls.assunto.value == item;
  }

  get consultaFiltrada() {
    const v = this.service.consulta.value;
    return {
      id: v.id,
      files: v.files,
      username: v.username,
      dataHoraAbertura: v.dataHoraAbertura,
      nome: v.nome,
      email: v.email,
      descricaoConsulta: v.descricaoConsulta,
      codigoCNS: v.codigoCNS,
      codigoCNSFormatado: v.codigoCNSFormatado,
      nomeResponsavelServentia: v.nomeResponsavelServentia,
      nomeMunicipioServentia: v.nomeMunicipioServentia,
      nomeServentia: v.nomeServentia,
      codigoMunicipioServentia: v.codigoMunicipioServentia,
      tipoClassificacao: v.tipoClassificacao,
      codigoComarca: v.codigoComarca,
      demandaRecebida: v.demandaRecebida,
      dadosRequerente: v.dadosRequerente,
      listaConciliador: v.listaConciliador,
      termoDeclaracaoVerdade: v.termoDeclaracaoVerdade,
      monitoramentoConciliacao: v.monitoramentoConciliacao
    };
  }

  get isMonitoramentoConciliacao(): boolean {
    return !!this.cartoriosExtrajudicialConsulta &&
      this.cartoriosExtrajudicialConsulta.mostrarMonitoramentoConciliacaoForm;
  }

  get deveMostrarAnexos(): boolean {
    if (!this.service.consulta.value.assunto) {
      return false;
    }

    if (this.cartoriosExtrajudicialConsulta && this.cartoriosExtrajudicialConsulta.mostrarRestituicaoForm) {
      return false;
    }

    if (this.isMonitoramentoConciliacao) {
      return false;
    }

    return true;
  }

  protected readonly Object = Object;
}
